(function () {
  'use strict';

  var pageClass = 'victron-collection-page';
  var analyticsEventName = 'victron_collection_interaction';

  function emitInteraction(name, label, properties) {
    var detail = Object.assign({
      interaction: name,
      label: label || '',
      collection_handle: 'brand-victron'
    }, properties || {});

    document.dispatchEvent(new CustomEvent('theme:victron-collection-interaction', {
      detail: detail
    }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: analyticsEventName }, detail));
    }
  }

  function initFaqs(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-victron-faq]'), function (details) {
      if (details.dataset.victronInitialized === 'true') return;
      details.dataset.victronInitialized = 'true';
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var summary = details.querySelector('summary');
        emitInteraction('faq_open', summary ? summary.textContent.trim() : 'FAQ');
      });
    });
  }

  function initPage(scope) {
    if (!document.documentElement.classList.contains(pageClass)) return;
    initFaqs(scope);
  }

  document.addEventListener('click', function (event) {
    if (!document.documentElement.classList.contains(pageClass)) return;

    var tracked = event.target.closest('[data-victron-event]');
    if (tracked) {
      emitInteraction(
        tracked.dataset.victronEvent,
        tracked.dataset.victronLabel || tracked.textContent.trim(),
        { destination: tracked.getAttribute('href') || '' }
      );
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPage(document); });
  } else {
    initPage(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-victron-hub]')) {
      document.documentElement.classList.add(pageClass);
    }
    initPage(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      if (!document.querySelector('[data-victron-hub]')) {
        document.documentElement.classList.remove(pageClass);
      }
    }, 0);
  });
}());
